export default "__VITE_ASSET__d2f1bd42__"